import { useCustomLocale } from '@/_hooks/useCustomLocale'
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog'
import { AspectRatio, Box, Button, Text } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import React from 'react'

const Popup = ({
  activePopup,
  onClose,
}: {
  activePopup: any
  onClose: () => void
}) => {
  const t = useTranslations()
  const currentLocale = useCustomLocale()

  const navigateToLink = (url: string) => {
    window.location.href = url
  }

  return (
    <DialogContent mx={4} p={1} rounded={18}>
      <DialogBody p={2}>
        <Box mb={30}>
          <AspectRatio ratio={2 / 1}>
            <Image
              src={process.env.BASE_URL + activePopup?.image?.[currentLocale]}
              alt={activePopup?.title?.[currentLocale] || 'Popup Image'}
              style={{
                objectPosition: 'center',
                borderRadius: '12px',
              }}
              fill
            />
          </AspectRatio>
          <Box px={4} py={2}>
            <Text as='p' fontSize='24px' fontWeight='bold'>
              {activePopup?.title?.[currentLocale]}
            </Text>
            <Text mt='8px' fontSize='14px' fontWeight='400px'>
              {activePopup?.about?.[currentLocale]}
            </Text>
          </Box>
        </Box>
      </DialogBody>
      <DialogFooter p={2}>
        <Button
          size='xs'
          bg='primary'
          color='primary.text'
          _hover={{ bg: 'primary.hover' }}
          style={{
            color: '#fff',
            width: '100%',
            fontWeight: 'bold',
            fontSize: '16px',
            borderRadius: '16px',
            height: '56px',
          }}
          mt={4}
          onClick={() => {
            if (activePopup?.url) navigateToLink(activePopup?.url)
            else onClose()
          }}
        >
          {activePopup?.button?.[currentLocale] || t('ok')}
        </Button>
      </DialogFooter>
      <DialogCloseTrigger />
    </DialogContent>
  )
}

export default Popup
